module.exports = __webpack_public_path__ + "media/images/download/e-book10-084412fb669bed26157264e9adf26137.png";